/**
 * Created by 唐亦慧 on 2017/8/29.
 */

import {config, request, objectSerial} from 'Utils';

//获取岗位列表
export function jobList(param) {
	return request(`${config.server}/api/v1/dms/post/list`,{
		method: 'post',
		body: param
	});
}


//修改岗位
export function jobModify(param) {
	return request(`${config.server}/api/v1/dms/post/update`,{
		method: 'post',
		body: param
	});
}


//获取子岗位--传父岗位id
export function childrenList(param) {
	return request(`${config.server}/api/v1/dmsPost/childList?${objectSerial(param)}`);
}


//获取详情
export function jobDetail(param) {
	return request(`${config.server}/api/v1/dms/post/detail?${objectSerial(param)}`);
}


//添加新岗位

/*
* {
 "active": 1,
 "code": "string",
 "name": "string",
 "parentId": 0
 }
* */
export function jobAdd(param) {
	return request(`${config.server}/api/v1/dms/post/insert`,{
		method: 'post',
		body: param
	});
}


//删除岗位--传id
export function jobDelete(param) {
	return request(`${config.server}/api/v1/dms/post/delete`,{
		method: 'post',
		body: param
	});
}

//获取树形图
export function jobTree(param) {
	return request(`${config.server}/api/v1/dms/post/tree?${objectSerial(param)}`);
}






// WEBPACK FOOTER //
// ./src/service/job/index.js